module.exports = __webpack_public_path__ + "static/media/caution.237df891.svg";